<template>
  <div v-loading="loading">
    <div class="well well-small">
      <iframe
        :src="dashboardUrl"
        width="100%"
        height="800"
        frameborder="0"
        style="margin-bottom: 15px;"
      >
      </iframe>
    </div>
  </div>
</template>

<script>
var VueCookie = require("vue-cookie");
import { sync, get } from "vuex-pathify"; // eslint-disable-line no-unused-vars

export default {
  name: "Dashboard",

  props: {
    largeProduction: {
      type: Boolean,
      default: false
    }
  },

  created() {
    this.retrieveAccessToken();
  },
  computed: {
    loading: get("dashboard/loading"),
    globalFieldSite: get("globalFieldSite"),
    globalCampaign: get("globalCampaign"),
  },
  data() {
    return {
      dashboardUrl: "",
    };
  },
  methods: {
    retrieveAccessToken() {
      this.identification = VueCookie.get('pc_identification') ? JSON.parse(VueCookie.get('pc_identification')) : null;
      const action = this.largeProduction
        ? "dashboard/generateLookerEmbedUrlLargeProduction"
        : "dashboard/generateLookerEmbedUrl";
      this.$store.dispatch(action, this.identification).then((embedUrl) => {
        this.dashboardUrl = embedUrl;
      }).catch((error) => {
        this.$notify.error({
          title: this.i18nValues["error"],
          message: error,
          position: "bottom-right",
          duration: 7000,
        });
      });
    },
  },
};
</script>
